export default __webpack_public_path__ + "static/media/instruction.387049a9.JPG";